module.exports = {
  handle: (e, response) => {
    const { gtmData: { currentStep, option, customerId, emailAddress } = {} } = response || {};

    dataLayer.push({ ecommerce: null });
    // Steps: Shipment = 1, payment = 2, Place Order = 3, submit order=4

    const checkoutOptionData = {
      event: 'eec.checkout_option',
      ecommerce: {
        checkout_option: {
            actionField: {
                step: currentStep || 1,
                option: option || 'N/A'
            }
          }
      }
    };

    customerId ? checkoutOptionData.userId = customerId : null;
    emailAddress ? checkoutOptionData.email = emailAddress : null;

    dataLayer.push(checkoutOptionData);
  }
}